import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { getData } from 'src/services/RestApi';
import SearchSelectField from 'src/components/widgets/search-select-field';
import { getCacheCarPartner } from 'src/utils/cache-data';

export const DropdownPricing = ({ formik, disabled = false, type = 'xd', name, hintValue, showPrice = true }) => {
  const [data, setData] = useState([]);
  const [defaultVal, setDefault] = useState(null);
  const isFetchingData = useRef(false); // Ref to track if the API call is in progress

  const formatNumberWithCommas = (value) => {
    if (!value) return '';
    //return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return value.toLocaleString();
  };

  // Memoize the API call function to avoid calls many more
  const fetchData = useCallback(async () => {
    if(isFetchingData.current) return;
    isFetchingData.current = true; // Set the flag to avoid API calls
    
    const { result } = await getData('fixed/pricing/list', {type: `${type}`});
    if (result) {
      const arrays = [];
      
      if(showPrice){
        result.forEach(element => {
          arrays.push({label: `${formatNumberWithCommas(element.price)} (${element.name})`, value: `${element.price}`});
        });
        // Using when pricing changed, and update late
        arrays.push({label: 'Đang cập nhật', value: '0'});
      }else{
        result.forEach(element => {
          arrays.push({label: `${element.name}`, value: `${element.id}`});
        });
      }

      setData(arrays);

      if(!hintValue){
        setDefaultByPlate(result);
      }
    }
    isFetchingData.current = false; // Reset the flag after fetching
  }, [data]);

  useEffect(() => {
    fetchData(); // Fetch data on component mount
  }, []);

  const setDefaultByPlate = (items) => {
    let myValue;
    const carId = formik.values?.plateField?.value;
    if(carId){
      const partners = getCacheCarPartner();
      const cache = partners[carId];
      if (cache && cache[type]) {
        myValue = cache[type].pricing;
      }
    }
    if (myValue) {
      // Find the matching element or default to the first element
      const current = items.find(element => element.id === myValue) || items[0];

      // Update Formik values and default state
      formik.values[name] = {label: `${formatNumberWithCommas(current.price)} (${current.code})`, value: `${current.price}`};
      setDefault(formik.values[name].value);
    }
  };

  const handleChanged = (selectedOption) => {
    formik.setFieldValue(name, selectedOption);
  };

  return (
    <SearchSelectField
      label="Đơn giá"
      name={name}
      disabled={disabled}
      options={data}
      onSelected={handleChanged}
      formik={formik}
      defaultValue={defaultVal} // {label: '<name>', value: '<id>'}
      hintValue={formatNumberWithCommas(hintValue) || ''} // '<name>'
    />
  );
};

DropdownPricing.propTypes = {
  formik: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
};

export default DropdownPricing;
